export default (sitemap: SitemapBuilder) =>
{
    sitemap.find('[[[System]]]', '[[[Ustawienia]]]').after('[[[Paleta kolorów]]]', [
        {
            name: '[[[Ipresso]]]',
            route: 'ipresso',
            icon: 'bullhorn',
            namespace: 'Ideo.Core.Integrations.Ipresso.Permissions',
            auth: { all: ['IpressoPermissions@Edit'], any: [] }
        }
    ]);
};
